
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_682_6204)"}},[_c('path',{attrs:{"d":"M10.077 6.129a4.941 4.941 0 00-4.936 4.936A4.941 4.941 0 0010.077 16a4.941 4.941 0 004.935-4.935 4.941 4.941 0 00-4.935-4.936zm-1.06 2.977a.686.686 0 11-.002 1.373.686.686 0 01.001-1.373zm2.12 3.917a.686.686 0 11.002-1.373.686.686 0 01-.002 1.373zm.578-2.866l-2.546 2.545a.516.516 0 11-.73-.73l2.546-2.545a.516.516 0 11.73.73zM8.69 0H5.335c-.392 0-.64.42-.453.764l.986 1.8a1.483 1.483 0 00-.535 2.004 5.236 5.236 0 00-3.454 3.964l-.844 4.4A2.58 2.58 0 003.569 16h2.15a.432.432 0 00.3-.742c-3.309-3.203-1.767-8.76 2.648-9.86a.431.431 0 00.025-.83 1.483 1.483 0 00-.535-2.005L9.142.764A.516.516 0 008.69 0zM7.4 4.29h-.775a.453.453 0 01-.428-.598.447.447 0 01.428-.305H7.4c.194 0 .37.121.429.305a.453.453 0 01-.429.598z","fill":"var(--theme-color-white-text)"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_682_6204"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    